"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalSheetGroups = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var ApprovalSheetGroup_1 = require("./ApprovalSheetGroup");
var styles_1 = require("@material-ui/core/styles");
var useApprovalSheetGroupsStyles = styles_1.makeStyles(function (theme) {
    return {
        root: {
            overflowX: 'auto',
            height: '100%',
            padding: '0 12px 12px',
        },
        groupContainer: {
            height: '100%',
        },
    };
});
exports.ApprovalSheetGroups = function (props) {
    var groups = props.groups;
    var lastIndex = groups.length - 1;
    var classes = useApprovalSheetGroupsStyles();
    return (react_1.default.createElement(core_1.Grid, { container: true, direction: "row", wrap: "nowrap", className: classes.root }, groups.map(function (group, index) { return (react_1.default.createElement(core_1.Grid, { item: true, key: group.groupTitle, className: classes.groupContainer },
        react_1.default.createElement(ApprovalSheetGroup_1.ApprovalSheetGroup, { group: group, isNotLast: index !== lastIndex }))); })));
};
